module.exports = __webpack_public_path__ + "static/img/szafa_dso_24.e2e48db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/szafa_dso_24.svg
// module id = TT0C
// module chunks = 1